/**
 * 앱 새로고침 — 웹/PWA의 새로고침 진입점 하나.
 *
 * PWA를 홈 화면에 설치하면 주소창이 없고, index.css의 `overscroll-behavior: none`이
 * 브라우저 기본 당김 새로고침까지 막아 사용자가 스스로 새로고침할 방법이 전혀 없었다.
 * 당김 제스처(PullToRefresh)·모바일 설정 탭 '새로고침' 행·서비스워커 업데이트 배너가
 * 모두 이 함수를 쓴다 — 새로고침 방식이 갈라지지 않도록 한 곳으로 모은다.
 *
 * reload 전에 서비스워커 갱신을 한 번 기다리는 이유: public/service-worker.js가 install에서
 * `skipWaiting()`, activate에서 `clients.claim()`을 호출하므로 update()가 새 SW를 잡아내면
 * 그 직후 reload 한 번으로 새 자산까지 적용된다. 다만 update()는 네트워크에 묶여 있어
 * 무한정 기다릴 수 없으므로 상한을 두고 시간이 지나면 그냥 reload 한다 —
 * 새로고침 자체가 늦어지는 편이 사용자에게 더 나쁘다.
 */
const SW_UPDATE_TIMEOUT_MS = 1500;

export async function refreshApp(): Promise<void> {
  try {
    // Tauri·비보안 컨텍스트에는 serviceWorker 자체가 없다
    const reg = await navigator.serviceWorker?.getRegistration();
    if (reg) {
      await Promise.race([
        reg.update().catch(() => {}),
        new Promise<void>(resolve => { setTimeout(resolve, SW_UPDATE_TIMEOUT_MS); }),
      ]);
    }
  } catch {
    // 갱신 확인에 실패해도 새로고침은 그대로 진행한다
  }
  window.location.reload();
}
